import React, { CSSProperties, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import './AppLoader.scss'

const AppLoader = (props: { showAppLoader: boolean; isAppLoaded: boolean }) => {
	const { showAppLoader, isAppLoaded } = props

	const componentClass = `smart-overlay-app-loader`

	const SmartlyLoader = `${
		process.env.SMARTLY_URL === 'http://localhost:5000'
			? 'https://smartly-dev.luxottica.com'
			: process.env.SMARTLY_URL
	}/styleguide/assets/images/smartly-loader.gif`

	return (
		<div
			className={`${componentClass} ${
				showAppLoader && !isAppLoaded
					? `${componentClass}--visible`
					: `${componentClass}--hidden`
			}`}>
			<img src={SmartlyLoader} />
		</div>
	)
}

const mapStateToProps = (state: any) => ({
	showAppLoader: state.overlayReducer.showAppLoader,
	isAppLoaded: state.overlayReducer.isAppLoaded,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AppLoader)
